// /utils/validator.js


export const isValidPassword = (password) => {
    const regex = /^[a-zA-Z0-9!@#$%^&*()\-_=+\[\]{}|\\:;"'<>,.?/~]{3,30}$/;
    return regex.test(password);
  };
  
  